import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import DepartmentSelect from '@/views/components/DepartmentSelect.vue'
import { DEPARTMENT_CODE } from "@/utils/pattern"
import { BASE_URL } from "@/api/system/department"

/**
 * 绘制新增表单
 */
 export function renderAddForm(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL 
    },
    '新增'
  )

  return addForm
}

const items = [
  [
    createFormItem('上级部门', 'parentId', DepartmentSelect as VueComponent),
    
  ],
  [
    createFormItem('部门名称', 'departmentName', FORM_ITEM.INPUT, { maxlength: '30' }),
    createFormItem('部门编码', 'departmentCode', FORM_ITEM.INPUT, { maxlength: '20' })
  ],
  [
    createFormItem('顺序', 'sort', FORM_ITEM.INPUT_NUMBER, { controlsPosition: 'right', min: 0, max: 1000 }),
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'DEPARTMENT_STATUS', default: true }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  departmentName: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
  departmentCode: [{ required: true, message: '请输入部门编码', trigger: 'blur' },
    { pattern: DEPARTMENT_CODE, required: true, message: '只能包含字母、数字、下划线', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
  sort: [{ required: true, message: '请输入顺序', trigger: 'blur' }]
}